import {Injectable, NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {UserRouteAccessService} from '../../core';
import {ResolvePagingParams} from '../../core/services';
import {Authority} from '../../shared/constants/authority.constants';
import {MembersComponent} from './members/members.component';

export const membersRoute: Routes = [
  {
    path: '',
    component: MembersComponent,
    resolve: {
      pagingParams: ResolvePagingParams
    },
    data: {
      authorities: [Authority.ADMIN],
      defaultSort: 'login,asc',
      title: 'User Management',
      headerDisplay: 'none',
    },
    canActivate: [UserRouteAccessService]
  }
];
